import React, { useState } from "react";
import SideMenuHOD from "../components/SideMenuHOD";
import UserMenu from "../components/UserMenu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import RegularizeTable from "../components/RegularizeTable";

const RegularizationApproval = () => {
  const [isChecked, setIsChecked] = useState(false);
  return (
    <div className="flex flex-col md:flex-row h-screen">
      <SideMenuHOD className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex-1">
          {" "}
          <div className="p-6 rounded-lg w-full">
            {/* Header */}
            <div className="flex items-center mb-4">
              <button className="text-xl font-bold">&larr;</button>
              <h2 className="text-lg font-semibold ml-2">Request Details</h2>
            </div>

            {/* Office Details */}
            <div className="border-b border-[#DCDCDC] pb-4">
              <h3 className="font-semibold mb-2 underline">Office Details :</h3>
              <p>
                <strong>Name :</strong> Rahul Rawat &nbsp; &nbsp;
                <strong>District :</strong> Dehradun &nbsp; &nbsp;
                <strong>Role :</strong> Clerk &nbsp; &nbsp;
                <strong>Sub-Registrar Office :</strong> Dehradun 1
              </p>
            </div>

            {/* Regularization Requested Details */}
            <div className="border-b border-[#DCDCDC] py-4">
              <h3 className="font-semibold mb-2 underline">
                Regularization Requested Details :
              </h3>
              <p>
                <strong>Name of Assignee :</strong> Rahul Rawat &nbsp; &nbsp;
                <strong>Assigned District :</strong> Dehradun &nbsp; &nbsp;
                <strong>Assigned Role :</strong> Clerk &nbsp; &nbsp;
                <strong>Assigned Sub-Registrar Office :</strong> Dehradun 1
              </p>
              <p>
                <strong>On Behalf of :</strong> Dehradun 1 &nbsp; &nbsp;
                <strong>From Date :</strong> Dehradun 1 &nbsp; &nbsp;
                <strong>To Date :</strong> Dehradun 1 &nbsp; &nbsp;
                <strong>Document :</strong>{" "}
                <a href="#" className="text-blue-500">
                  View
                </a>
              </p>
            </div>

            {/* Action Section */}
            <div className="mt-4">
              <h3 className="font-semibold mb-2">Action :</h3>
              <div className="flex items-center mb-4">
                <input
                  type="checkbox"
                  id="consent"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                  className="mr-2"
                />
                <label htmlFor="consent" className="text-sm">
                  I hereby give consent that I have viewed the request and
                  authorize to change the power of Requested Assignee.
                </label>
              </div>

              {/* Buttons */}
              <div className="flex gap-4">
                <button
                  disabled={!isChecked}
                  className={`px-4 py-2 text-white font-semibold rounded-md transition ${
                    isChecked
                      ? "bg-[#1F9B00] hover:bg-[#418a2e]"
                      : "bg-[#8d8d8d] cursor-not-allowed"
                  }`}
                >
                  Approve Request ✅
                </button>
                <button
                  disabled={!isChecked}
                  className={`px-4 py-2 font-semibold border rounded-md transition ${
                    isChecked
                      ? "border-[#E80000] text-[#E80000] hover:bg-[#c43d3d]"
                      : "border-[#7a6b6b] text-[#a7a7a7] cursor-not-allowed"
                  }`}
                >
                  Reject Request ❌
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer (Spans Only MainContent) */}
        <div className="p-0 bg-blue-100 text-center">
          <Footer />
        </div>
      </div>

      {/* Right Sidebar (Hidden on Mobile, Visible on Medium Screens and Above) */}

      {/* Mobile Bottom Navigation (Visible on Mobile, Hidden on Medium Screens and Above) */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg md:hidden">
        <div className="flex justify-around p-2">
          {/* Mobile Menu Items */}
          <button
            onClick={() => {
              /* Toggle Left Sidebar */
            }}
          >
            {/* Icon for Menu */}
          </button>
          <button
            onClick={() => {
              /* Toggle Right Sidebar */
            }}
          >
            {/* Icon for User Menu */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegularizationApproval;
